module.exports = __webpack_public_path__ + "static/img/aboutUs11.041836b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs11.jpg
// module id = 1363
// module chunks = 1